import angular from 'angular';

import radarFactory from './radar';

export default angular.module('radar.core', [])
  .factory('radar', radarFactory)
  .name;



/** WEBPACK FOOTER **
 ** ./src/app/core/index.js
 **/